// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + "ranking" + "." + "5331c081" + ".chunk.css");